require("../sass/vendor/_bootstrap.scss")
require("../sass/vendor/_tachyons.scss")

// require('slick-carousel/slick/slick.css')
// require('slick-carousel/slick/slick-theme.css')
// require('../sass/vendor/colorbox.scss')



// WEBPACK FOOTER //
// ./assets/js/styles.js